import { render, staticRenderFns } from "./GastosCompras.vue?vue&type=template&id=99f932f8&scoped=true"
import script from "./GastosCompras.vue?vue&type=script&lang=js"
export * from "./GastosCompras.vue?vue&type=script&lang=js"
import style0 from "./GastosCompras.vue?vue&type=style&index=0&id=99f932f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f932f8",
  null
  
)

export default component.exports